import script from "./goRinSyo0036.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0036.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0036.vue?vue&type=style&index=0&id=1beb2939&lang=scss"

const __exports__ = script;

export default __exports__